import React from "react";
import Common_Title from "../../common-components/common_title/Common_Title";
import "./Our_Commitment.css";
import parse from "html-react-parser";

function Our_Commitment({ content, app_setup }) {
  const statsData = [
    {
      value: `${app_setup?.available_medicines || 1000}+`,
      label: "Medicines Available",
    },
    {
      value: `${app_setup?.happy_customers || 50000}+`,
      label: "Happy Customers",
    },
    {
      value: `${app_setup?.trusted_brand || 50}+`,
      label: "Trusted Brands",
    },
    {
      value: "24/7",
      label: "Customer Support",
    },
  ];
  return (
    <section className="our_commitment">
      <div className="container">
        <div className="row">
          <div className="col-lg-5 col-md-12 col-sm-12">
            <div className="description_card ">
              <Common_Title titleStart={content?.name || ""} />
              <div className="text_wrapper">
                <p className="text">{parse(content?.subname || "")}</p>
              </div>
              <div className=" stats-section">
                <div className="row">
                  {statsData.map((item, index) => (
                    <div className="col-lg-6 col-md-6 col-6">
                      <div className=" description_card inner_card" key={index}>
                        <h3 className="stat_value">{item.value}</h3>
                        <p className="stat_label">{item.label}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className=" col-lg-7 col-md-12 col-sm-12">
            <div className="img_wrapper">
              <img
                src={process.env.REACT_APP_IMG_URL + content?.image}
                // src="/assets/images/about_us/commitment/commitment-img.png"
                alt="commitment_img"
                className="commitment_img"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Our_Commitment;
